
import { defineComponent, PropType, ref, computed } from "@vue/runtime-core";
import TextButton from "../Buttons/TextButton.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { CashRegister } from "@/types/CashRegister";
import { mdiChevronDown } from "@mdi/js";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition";
import { useForm } from "@inertiajs/inertia-vue3";
import Button from "../Buttons/Button.vue";
import Modal from "../General/Modal.vue";
import { Inertia } from "@inertiajs/inertia";

export default defineComponent({
  props: {
    register: {
      type: Object as PropType<CashRegister>,
      required: true,
    }
  },
  setup(props) {
    const open = ref(true);

    const openButtonClasses = computed(() => {
      return {
        open: open.value,
      }
    });

    const form = useForm({
      _method: "PUT",
      name: props.register.name,
      terminal_id: props.register.terminal_id as string | undefined,
      terminal_is_mobile: props.register.terminal_is_mobile,
      receipt_printer: props.register.receipt_printer,
    });

    const sendForm = () => {
      if (form.terminal_is_mobile) {
        form.terminal_id = undefined;
      }

      form.post(route("cash-registers.update", { cash_register: props.register.id }));
    }

    const abortEdit = () => {
      form.reset();
      open.value = false;
    }

    const showDeleteModal = ref(false);

    const deleteRegister = () => {
      Inertia.post(route("cash-registers.destroy", { cash_register: props.register.id }), {
        _method: "DELTE",
      }, {
        onSuccess: () => showDeleteModal.value = false,
      });
    }

    return {
      form,
      open,
      sendForm,
      abortEdit,
      deleteRegister,
      showDeleteModal,
      openButtonClasses,
      arrowDownIcon: mdiChevronDown,
    };
  },
  components: { TextButton, SvgIcon, CollapseTransition, Button, Modal }
});
